import React from 'react';
import { Box } from '@hub/box';
import { kebabCase } from 'lodash';
import * as paths from './paths';
import { LinkSection } from './link-section';
import { GIFT_CARDS } from '../../paths';
import { trackUniversalFooterLinkClick } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const giftCards = {
  heading: {
    text: 'Westfield Gift Cards',
    url: GIFT_CARDS
  },
  links: [{
    text: 'Digital Gift Card',
    url: paths.GIFT_CARDS_DIGITAL_RETAIL
  }, {
    text: 'Gift Card',
    url: paths.GIFT_CARDS_PHYSICAL_RETAIL,
    newTab: true,
    links: [{
      text: 'Terms and Conditions',
      url: paths.TERMS_CONDITIONS,
      newTab: true
    }]
  }, {
    text: 'Corporate',
    url: paths.GIFT_CARDS_PHYSICAL_CORPORATE,
    newTab: true
  }]
};
const westfieldOnline = {
  heading: {
    text: 'Online shopping',
    url: paths.WESTFIELD_ONLINE
  },
  links: [{
    text: 'About',
    url: paths.SHOP_ABOUT,
    newTab: true
  }, {
    text: 'Click & Collect',
    url: paths.SHOP_CLICK_COLLECT,
    newTab: true
  }, {
    text: 'Delivery',
    url: paths.SHOP_DELIVERY,
    newTab: true
  }, {
    text: 'Returns',
    url: paths.SHOP_RETURNS,
    newTab: true
  }, {
    text: 'Brands',
    url: paths.SHOP_BRANDS,
    newTab: false
  }, {
    text: 'Curated Collections',
    url: paths.PRODUCT_COLLECTIONS,
    newTab: false
  }, {
    text: 'Size Guide',
    url: paths.SHOP_SIZE_GUIDE,
    newTab: false
  }, {
    text: 'Terms and Conditions',
    url: paths.TERMS_CONDITIONS_WESTFIELD_ONLINE,
    newTab: false
  }, {
    text: 'Online Promotions',
    url: paths.ONLINE_PROMOTIONS,
    newTab: false
  }, {
    text: 'Privacy Statement',
    url: paths.PRIVACY_POLICY_WESTFIELD_ONLINE,
    newTab: false
  }, {
    text: 'FAQs',
    url: paths.FAQS,
    newTab: true
  }]
};
const westfieldOnlineDecommissionMode = {
  heading: {
    text: 'Online shopping',
    url: paths.WESTFIELD_ONLINE
  },
  links: [{
    text: 'Terms and Conditions',
    url: paths.TERMS_CONDITIONS_WESTFIELD_ONLINE,
    newTab: false
  }, {
    text: 'Privacy Statement',
    url: paths.PRIVACY_POLICY_WESTFIELD_ONLINE,
    newTab: false
  }, {
    text: 'FAQs',
    url: paths.FAQS,
    newTab: true
  }]
};
export const LeftColumnLinks = _ref => {
  let {
    isOnlineDecommissionMode
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      as: "nav",
      "aria-labelledby": isOnlineDecommissionMode ? kebabCase(westfieldOnlineDecommissionMode.heading.text) : kebabCase(westfieldOnline.heading.text),
      sx: {
        flexGrow: 1
      },
      "data-id": "universal-footer_left-column-links_LeftColumnLinks_Box",
      children: /*#__PURE__*/_jsx(LinkSection, {
        heading: isOnlineDecommissionMode ? westfieldOnlineDecommissionMode.heading : westfieldOnline.heading,
        links: isOnlineDecommissionMode ? westfieldOnlineDecommissionMode.links : westfieldOnline.links,
        trackers: {
          clicked: trackUniversalFooterLinkClick
        },
        "data-id": "universal-footer_left-column-links_LeftColumnLinks_Box_LinkSection"
      })
    }), /*#__PURE__*/_jsx(Box, {
      as: "nav",
      "aria-labelledby": kebabCase(giftCards.heading.text),
      sx: {
        flexGrow: 1
      },
      "data-id": "universal-footer_left-column-links_LeftColumnLinks_Box",
      children: /*#__PURE__*/_jsx(LinkSection, {
        heading: giftCards.heading,
        links: giftCards.links,
        trackers: {
          clicked: trackUniversalFooterLinkClick
        },
        "data-id": "universal-footer_left-column-links_LeftColumnLinks_Box_LinkSection"
      })
    })]
  });
};